export const DROPDOWN_INTERACTION =
  "product-pages-colour-selector-dropdown-interaction";
export const DROPDOWN_SELECT_COLOUR =
  "product-pages-colour-selector-dropdown-select";
export const DROPDOWN_SELECT_PROMO_COLOUR =
  "product-pages-colour-selector-dropdown-select-promo";

export const SWATCHES_SELECT_COLOUR =
  "product-pages-colour-selector-swatch-click";
export const SWATCHES_SELECT_PROMO_COLOUR =
  "product-pages-colour-selector-promo-swatch-click";

export const SWATCHES_SELECT_POSITION_1_5 =
  "product-pages-colour-selector-bucket-1";
export const SWATCHES_SELECT_POSITION_6_10 =
  "product-pages-colour-selector-bucket-2";
export const SWATCHES_SELECT_POSITION_11_PLUS =
  "product-pages-colour-selector-bucket-3";
export const COLOUR_SELECTOR_SHOW_MORE_BUTTON_CLICK =
  "product-pages-colour-selector-show-more-button-click";
